import lodash from 'lodash';
import { mutateInputWithCurrentTime } from 'common/util/dateTime';

export const INDEX_DOCUMENT_DESCRIPTOR_CHANGE_EDITOR_VALUE = 'INDEX_DOCUMENT_DESCRIPTOR_CHANGE_EDITOR_VALUE';
export const INDEX_DOCUMENT_DESCRIPTOR_ADD_VALUE = 'INDEX_DOCUMENT_DESCRIPTOR_ADD_VALUE';
export const INDEX_DOCUMENT_DESCRIPTOR_REMOVE_VALUE = 'INDEX_DOCUMENT_DESCIRPTOR_REMOVE_VALUE';
export const INDEX_DOCUMENT_DESCRIPTOR_MARK_VALUE_VALIDITY = 'INDEX_DOCUMENT_DESCRIPTOR_MARK_VALUE_VALIDITY';
export const INDEX_DOCUMENT_DESCRIPTOR_SET_HIGHLIGHT_INDEX = 'INDEX_DOCUMENT_DESCRIPTOR_SET_HIGHLIGHT_INDEX';
export const INDEX_DOCUMENT_DESCRIPTOR_SET_MESSAGE = 'INDEX_DOCUMENT_DESCRIPTOR_SET_MESSAGE';
export const INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_EDITING_FLAG = 'INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_EDITING_FLAG';
export const INDEX_DOCUMENT_DESCRIPTOR_VALUE_COMMIT_CHANGE = 'INDEX_DOCUMENT_DESCRIPTOR_VALUE_COMMIT_CHANGE';
export const INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_VALUE = 'INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_VALUE';
export const INDEX_DOCUMENT_DESCRIPTOR_VALUE_MARK_VALUE_VALIDITY = 'INDEX_DOCUMENT_DESCRIPTOR_MARK_VALUE_VALIDITY';

export function changeEditorValue(descriptorId, value, dataType) {
    const mutatedValue = mutateInputWithCurrentTime(value, dataType);
    return {
        type: INDEX_DOCUMENT_DESCRIPTOR_CHANGE_EDITOR_VALUE,
        payload: {
            descriptorId,
            value: mutatedValue
        }
    };
}

export function addValue(descriptorId, value) {
    return {
        type: INDEX_DOCUMENT_DESCRIPTOR_ADD_VALUE,
        payload: {
            descriptorId,
            value
        }
    };
}

export function removeValue(descriptorId, index) {
    return (dispatch, getState) => {
        const storeState = getState();
        const values = lodash.get(storeState, ['indexDocument', 'descriptorValues', descriptorId, 'values']);
        dispatch({
            type: INDEX_DOCUMENT_DESCRIPTOR_REMOVE_VALUE,
            payload: {
                descriptorId,
                index,
                remainingItems: values.length - 1
            }
        });
    };

}

export function markValueInvalid(descriptorId, value) {
    return {
        type: INDEX_DOCUMENT_DESCRIPTOR_MARK_VALUE_VALIDITY,
        payload: {
            descriptorId,
            value: value
        }
    };
}

export function setHighlightIndex(descriptorId, index) {
    return (dispatch, getState) => {
        const storeState = getState();
        const values = lodash.get(storeState, ['indexDocument', 'descriptorValues', descriptorId, 'values']);
        index = lodash.clamp(index, -2, values.length);
        if (index >= values.length) {
            index = -1;
        } else if (index <= -2) {
            //allows to cycle around
            index = values.length - 1;
        }
        dispatch({
            type: INDEX_DOCUMENT_DESCRIPTOR_SET_HIGHLIGHT_INDEX,
            payload: {
                descriptorId,
                index
            }
        });
    };
}

export function setMessage(descriptorId, message) {
    return {
        type: INDEX_DOCUMENT_DESCRIPTOR_SET_MESSAGE,
        payload: {
            descriptorId,
            message
        }
    };
}

export function setValueEditMode(descriptorId, valueIndex, value) {
    return (dispatch, getState) => {
        const storeState = getState();
        const { value: valueBeforeEdit } = lodash.get(storeState, [
            'indexDocument', 'descriptorValues', descriptorId, 'values', valueIndex
        ], {});
        dispatch({
            type: INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_EDITING_FLAG,
            payload: {
                descriptorId,
                valueIndex,
                value,
                valueBeforeEdit
            }
        });
    };

}

export function commitValueChange(descriptorId, valueIndex, value) {
    return (dispatch, getState) => {
        const storeState = getState();
        const { invalidValue } = lodash.get(storeState, [
            'indexDocument', 'descriptorValues', descriptorId, 'values', valueIndex
        ]);
        if (invalidValue) {
            return;
        }
        dispatch({
            type: INDEX_DOCUMENT_DESCRIPTOR_VALUE_COMMIT_CHANGE,
            payload: {
                descriptorId,
                valueIndex,
                value
            }
        });
    };
}

export function setValue(descriptorId, valueIndex, value) {
    return {
        type: INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_VALUE,
        payload: {
            descriptorId,
            valueIndex,
            value
        }
    };
}

export function markChangeValueInvalid(descriptorId, valueIndex, value) {
    return {
        type: INDEX_DOCUMENT_DESCRIPTOR_VALUE_MARK_VALUE_VALIDITY,
        payload: {
            descriptorId,
            valueIndex,
            value
        }
    };
}